import {
  ANGANWADI_CENTER,
  ANGANWADI_HELPER,
  ANGANWADI_TEACHER,
  CHILD,
  COMMUNITY_HEALTH_CENTER,
  DISTRICT_COLLECTOR,
  DISTRICT_HEALTH_OFFICER,
  DISTRICT_HOSPITAL,
  DOCTOR,
  INSPECTION_OFFICER,
  PUBLIC_HEALTH_CENTRE,
  PARENT,
  ADMIN,
} from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'
import { DISPLAY_DATE_FORMAT } from '../../utils/dayjs'

const {
  admin,
  hospital,
  hospitalStaff,
  paediatrician,
  parent,
  children,
  paediatricianAssistant,
  districtCollector,
  inspectionOfficer,
  districtHealthOfficer,
  districtHospital,
  publicHealthCentre,
  communityHealthCentre,
  anganwadiCenter,
  anganwadiTeacher,
  anganwadiHelper,
  doctor,
  child,
} = userWiseRole

const userTranslationKey = {
  [admin]: 'user_Admin',
  [parent]: 'user_Parent',
  [child]: 'user_Child',
  [districtCollector]: 'user_DistrictCollector',
  [inspectionOfficer]: 'user_InspectionOfficer',
  [anganwadiCenter]: 'user_AnganwadiCentre',
  [anganwadiTeacher]: 'user_AnganwadiTeacher',
  [anganwadiHelper]: 'user_AnganwadiHelper',
  [districtHealthOfficer]: 'user_DistrictHealthOfficer',
  [districtHospital]: 'user_DistrictHospital',
  [publicHealthCentre]: 'user_PublicHealthCentre',
  [communityHealthCentre]: 'user_CommunityHealthCentre',
  [doctor]: 'user_Doctors',
}

const userRelationKey = {
  associate: 'ASSOCIATE',
  nonAssociate: 'NON_ASSOCIATE',
  childAssociate: 'CHILD_AND_ASSOCIATE',
}

const roleIdByPath = {
  [ADMIN]: admin,
  [PARENT]: parent,
  [CHILD]: child,
  [DISTRICT_COLLECTOR]: districtCollector,
  [INSPECTION_OFFICER]: inspectionOfficer,
  [ANGANWADI_CENTER]: anganwadiCenter,
  [ANGANWADI_TEACHER]: anganwadiTeacher,
  [ANGANWADI_HELPER]: anganwadiHelper,
  [DISTRICT_HEALTH_OFFICER]: districtHealthOfficer,
  [DISTRICT_HOSPITAL]: districtHospital,
  [PUBLIC_HEALTH_CENTRE]: publicHealthCentre,
  [COMMUNITY_HEALTH_CENTER]: communityHealthCentre,
  [DOCTOR]: doctor,
}

const booleanOption = [
  { label: 'btn_Yes', value: true },
  { label: 'btn_No', value: false },
]

const bloodGroupOption = [
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A-' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B-' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB-' },
  { label: 'O+', value: 'O+' },
  { label: 'O-', value: 'O-' },
]

const anganwadiProjectOptions = [
  { label: 'Nirmal', value: 'NIRMAL' },
  { label: 'Mudhole', value: 'MUDHOLE' },
  { label: 'Khanapur', value: 'KHANAPUR' },
  { label: 'Bhainsa(NEW)', value: 'BHAINSA_NEW' },
]

const commonForm = {
  address: {
    label: 'user_Address',
    validateTrigger: 'onChange',
    inputType: 'autoCompleteAddress',
    required: true,
    md: 24,
    xs: 24,
  },
  city: {
    label: 'user_City',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    md: 12,
    xs: 24,
    // options: cityOptions,
    // inputType: 'select',
    // disabled: true,
  },
  state: {
    label: 'user_State',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    md: 12,
    xs: 24,
    // inputType: 'select',
    // options: stateOptions,
    // disabled: true,
  },
  country: {
    label: 'txt_Country',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    md: 24,
    xs: 24,
    // inputType: 'select',
    // disabled: true,
    // options: countryOptions,
  },
  pincode: {
    label: 'user_Pincode',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    className: 'show-clear-icon w-100',
    required: true,
    allowClear: true,
    md: 24,
    xs: 24,
    // inputType: 'input',
    // options: pincodeOptions,
    // disabled: true,
  },
  emailId: {
    label: 'user_Email',
    validateTrigger: 'onChange',
    inputType: 'input',
    validateKey: 'emailId',
    addMore: true,
    maxField: 10,
    addMoreLabel: 'btn_AddMoreEmail',
    addMoreError: 'error_InvalidEmail',
    additionalLabel: 'user_AdditionalEmail',
    md: 24,
    xs: 24,
  },
  phoneNumber: {
    label: 'user_Contact',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
}

const commonWithUserNamePassword = {
  sameAsParentBtn: {
    inputType: 'button',
    type: 'primary',
    style: { float: 'right' },
    hidden: true,
    xs: 24,
  },
  ...commonForm,
  inchargeName: {
    label: 'user_InChargeName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  username: {
    label: 'auth_UserName',
    validateTrigger: 'onChange',
    inputType: 'input',
    autoComplete: 'off',
    required: true,
    md: 24,
    xs: 24,
  },
  password: {
    label: 'auth_Password',
    validateTrigger: 'onChange',
    inputType: 'password',
    required: true,
    autoComplete: 'new-password',
    md: 24,
    xs: 24,
  },
}

const addUserForm = {
  profile: {
    validateTrigger: 'onChange',
    inputType: 'formUpload',
    uploadSingle: true,
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    md: 12,
    xs: 12,
    hasApiCall: false,
    filePath: ['profile'],
  },
  businessName: {
    label: 'user_BusinessName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
  lastName: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: true,
  },
  designation: {
    label: 'user_Designation',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
    required: false,
  },
  ...commonWithUserNamePassword,
}
const addBuildingForm = {
  name: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    xs: 24,
  },
  ...commonForm,
}

const addAnganwadiForm = {
  awcId: {
    label: 'user_AWCRegNo',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100 remove-increment-counter',
    md: 12,
    xs: 24,
  },
  project: {
    label: 'user_Project',
    validateTrigger: 'onChange',
    inputType: 'select',
    options: anganwadiProjectOptions,
    required: true,
    md: 12,
    xs: 24,
  },
  wardNameAndNo: {
    label: 'user_WardNameAndNo',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 12,
    xs: 24,
  },
  supervisorName: {
    label: 'user_SupervisorName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 12,
    xs: 24,
  },
  supervisorPhoneNumber: {
    label: 'user_SupervisorContactNumber',
    validateTrigger: 'onChange',
    inputType: 'input',
    validateKey: 'phoneNumber',
    md: 12,
    xs: 24,
  },
  awtDtos: {
    md: 24,
    xs: 24,
    addMore: true,
    multiFields: [
      {
        label: 'user_AWTName',
        name: 'name',
        validateTrigger: 'onChange',
        inputType: 'input',
        md: 12,
        xs: 24,
      },
      {
        label: 'user_AWTContactNumber',
        name: 'phoneNumber',
        validateTrigger: 'onChange',
        inputType: 'input',
        validateKey: 'phoneNumber',
        md: 11,
        xs: 24,
      },
    ],
  },
  awhDtos: {
    md: 24,
    xs: 24,
    addMore: true,
    multiFields: [
      {
        label: 'user_AWHName',
        name: 'name',
        validateTrigger: 'onChange',
        inputType: 'input',
        md: 12,
        xs: 24,
      },
      {
        label: 'user_AWHContactNumber',
        name: 'phoneNumber',
        validateTrigger: 'onChange',
        inputType: 'input',
        validateKey: 'phoneNumber',
        md: 11,
        xs: 24,
      },
    ],
  },
}

const { ...userFormFields } = addUserForm
const { businessName, ...childUserFormFields } = userFormFields

const userFormByRoleId = {}

const RATING_LENGTH = 5

const userAffiliationByRoleId = {
  [admin]: [
    'user_NoofHospital',
    'user_NoofPaediatrician',
    'user_NoofParent',
    'user_NoofChildren',
  ],
  [hospital]: [
    'user_NoofPaediatrician',
    'user_NoofParent',
    'user_NoofChildren',
  ],
  [hospitalStaff]: [
    'user_NoofPaediatrician',
    'user_NoofParent',
    'user_NoofChildren',
  ],
  [paediatrician]: [
    'user_NoofPaediatricianAssistant',
    'user_NoofParent',
    'user_NoofChildren',
  ],
  [paediatricianAssistant]: ['user_NoofParent', 'user_NoofChildren'],
  [parent]: ['user_NoofChildren'],
  [children]: null,
}

const tileKeys = {
  user_PreAnteNatal: 'PRE_NATAL',
  user_PostNatal: 'POST_NATAL',
  user_ChildCare: 'CHILD_CARE',
  user_SpecialConditions: 'SPECIAL_CONDITION',
}

const growthFields = {
  date: {
    label: 'user_date',
    validateTrigger: 'onChange',
    inputType: 'dateTimePicker',
    format: DISPLAY_DATE_FORMAT,
    className: 'w-100',
    required: true,
    md: 24,
    sm: 24,
  },
  height: {
    label: 'user_Height',
    placeHolder: 'user_Height',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 24,
    sm: 24,
  },
  weight: {
    label: 'user_Weight',
    placeHolder: 'user_Weight',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 24,
    sm: 24,
  },
  headCircumference: {
    label: 'user_HeadCircumference',
    placeHolder: 'user_HeadCircumference',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 24,
    sm: 24,
  },
  midArmCircumference: {
    label: 'user_MidArmCircumference',
    placeHolder: 'user_MidArmCircumference',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    className: 'w-100',
    md: 24,
    sm: 24,
  },
}

const growthInitialState = {
  height: '',
  weight: '',
  headCircumference: '',
  midArmCircumference: '',
  date: '',
}

const associateKey = {
  user_StateHostelDepartment: 'user_AssociatedStateHostelDepartment',
  user_DistrictCollector: 'user_AssociatedDistrictCollector',
}

const countriesList = {
  India: 'in',
  Japan: 'jp',
  China: 'cn',
  NewZealand: 'nz',
  'United States': 'us',
  Canada: 'ca',
  Thailand: 'th',
}

export {
  addBuildingForm,
  associateKey,
  childUserFormFields,
  countriesList,
  growthFields,
  growthInitialState,
  RATING_LENGTH,
  roleIdByPath,
  tileKeys,
  userAffiliationByRoleId,
  userFormByRoleId,
  userFormFields,
  userRelationKey,
  userTranslationKey,
  booleanOption,
  bloodGroupOption,
  addAnganwadiForm,
  anganwadiProjectOptions,
}
